import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { RatePlanBrief } from '../../types/rateplan'
import { RoomTypeFilters } from '../../types/roomtype'
import RatePlanRow from './RateplanRow'
import RateplanRowSkeleton from './RateplanRow.skeleton'
import useStyles from './styles/RateplansTable.styles'

interface RateplansTableProps {
  loading: boolean
  data: RatePlanBrief[]
  reloadData: () => void
  hasAccessToViewRatePlanTabs: boolean | undefined
  isRoleAdmin: boolean
  setFilters: React.Dispatch<React.SetStateAction<RoomTypeFilters>>
}

export const RateplansTable: React.FC<RateplansTableProps> = ({
  loading,
  data,
  reloadData,
  hasAccessToViewRatePlanTabs,
  isRoleAdmin,
  setFilters
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div
        className={[
          classes.tableHead,
          isRoleAdmin ? classes.tableHeadAdmin : ''
        ].join(' ')}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Type')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Room Type')}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate('No. of Rates')}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Board Type')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Provider')}</Typography>
        </div>
        {isRoleAdmin && (
          <>
            <div>
              <Typography variant="body1">{getTranslate('Deleted')}</Typography>
            </div>
            <div>
              <Typography variant="body1">
                {getTranslate('Deactive')}
              </Typography>
            </div>
          </>
        )}
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
              setFilters({
                type: 'all',
                existing: 'all',
                activation: 'all'
              })
            }}>
            <RefreshIcon />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(' ')
            .map((_, index) => (
              <RateplanRowSkeleton
                key={`rateplan-row-skeleton${index.toString()}`}
              />
            ))
        : data.map((singleRateplan, index) => (
            <RatePlanRow
              key={index}
              hasAccessToViewRatePlanTabs={hasAccessToViewRatePlanTabs}
              data={singleRateplan}
              roomTypeid={singleRateplan.roomTypeID || ''}
              roomTypeName={singleRateplan.roomTypeName}
              isRoleAdmin={isRoleAdmin}
            />
          ))}
    </div>
  )
}
